import { createApi, fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";
import getBaseUrl from "../getBaseUrl";

const maxRetries = 2;

const dynamicBaseQuery = async (args: any, api: any, extraOptions: any) => {
  const rawBaseQuery = fetchBaseQuery({ baseUrl: getBaseUrl() });
  return rawBaseQuery(args, api, extraOptions);
};

const baseQuery = retry(dynamicBaseQuery, { maxRetries });

export const actionAPI = createApi({
  reducerPath: "actionAPI",
  baseQuery,
  keepUnusedDataFor: 0,
  tagTypes: ["tagGetActions"],
  refetchOnMountOrArgChange: true,
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    //* *********************************************************** */
    //* GET ALL ACTIONS */
    getActions: builder.query({
      query: (body: any) => ({
        url: `/action-catalogs/?page=${body.page}&limit=${body.limit}`,
        headers: { authorization: body.token },
      }),
      providesTags: ["tagGetActions"],
    }),
    //* *********************************************************** */
    //* CREATE ACTION */
    postAction: builder.mutation({
      query: (body: any) => ({
        url: "/action-catalogs/",
        method: "post",
        body: body.body,
        headers: { authorization: body.token },
      }),
      invalidatesTags: ["tagGetActions"],
    }),
    //* *********************************************************** */
    //* DELETE ACTION */
    deleteAction: builder.mutation({
      query: (body: any) => ({
        url: `/action-catalogs/${body.id}`,
        method: "delete",
        headers: { authorization: body.token },
      }),
      invalidatesTags: ["tagGetActions"],
    }),
    //* *********************************************************** */
    //* EDIT ACTION */
    putAction: builder.mutation({
      query: (body: any) => ({
        url: `/action-catalogs/${body.id}`,
        method: "put",
        body: body.body,
        headers: { authorization: body.token },
      }),
      invalidatesTags: ["tagGetActions"],
    }),
  }),
});

export const {
  useGetActionsQuery,
  usePostActionMutation,
  usePutActionMutation,
  useDeleteActionMutation,
} = actionAPI;
